var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{attrs:{"controls":"","src":_vm.videoUrl}},[_vm._v("您的浏览器不支持 video 标签。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }